export default {"src":"/_next/static/media/play-space.08263416.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};